import { FC } from "react";
import PageSection from "../../parts/StaticPageSection";
import { Helmet } from "react-helmet";
import { LecalSection } from "../../parts/LecalSection";

export const PrivacyPolicyPage: FC = () => {
  return <>
    <Helmet>
      <title>プライバシーポリシー - Drop AI</title>
      <meta name="description" content="Drop AIのプライバシーポリシーを確認できます。" />

      <meta property="og:url" content="https://drop4i.com/privacy-policy" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="プライバシーポリシー - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="Drop AIのプライバシーポリシーを確認できます。" />
    </Helmet>
    <PageSection title="プライバシーポリシー">
      <div>株式会社 GO TO MARKET（以下「当社」といいます。住所：東京都渋谷区道玄坂1-2-3 渋谷フクラス17階、代表者の氏名：木村暁生）は、当社の提供するDrop AI（ https://drop4i.com、以下「本サービス」といいます。）における、利用者の個人情報等の取扱いについて、以下のとおりプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。なお、本ポリシーの用語の定義は、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）及び関連法令に準拠するものとします。</div>

<LecalSection title="1. 取得する利用者の情報及び取得方法" value={`本サービスにおいて当社が取得する利用者の情報（個人情報を含む。以下同じ）は、その取得方法に応じて、以下のとおりとなります。
なお、本サービスの利用に関連して、他の外部サービス事業者が利用者の情報を取得する場合があります。当該外部サービス事業者による個人情報等の取扱いについては、本プライバシーポリシーではなく当該外部サービス事業者のプライバシーポリシー等が適用されるため、そちらをご確認ください。

(1) サービス利用情報
本サービスを利用するために、または本サービスの利用を通じて利用者からご提供いただく情報は以下のとおりです。
・アカウント名(ニックネームを含む)、メールアドレスなどの情報等

(2) 利用者が本サービスの利用において、他の外部サービスと連携を許可することにより、当該外部サービスからご提供いただく情報
利用者が、本サービスを利用するにあたり、Google、Apple等の外部サービスとの連携を許可した場合には、その許可の際にご同意いただいた内容に基づき、以下の情報を当該外部サービスから取得します。
・当該外部サービスで利用者が利用するID情報等
・その他当該外部サービスのプライバシー設定により利用者が連携先に開示を認めた情報等

(3) 利用者が本サービスを利用するにあたって、当社が取得する情報
当社は、本サービスへのアクセス状況やそのご利用方法に関する情報を取得することがあります。これには以下の情報が含まれます。
・リファラ等
・IPアドレス等
・サーバーアクセスログ、サービス内での行動履歴に関する情報等
・Cookie、ADID、IDFAその他の識別子等
・利用者が本サービスを利用するにあたり入力又は送信する情報（言語、画像等を含む）等`}></LecalSection>

<LecalSection title="2. 利用目的" value={`当社は、取得した利用者の情報を、以下の利用目的で利用いたします。
(1) 本サービスに関する登録の受付、本人確認、利用者認証、利用者設定の記録、利用者の管理、利用料金の決済計算等本サービスの提供、維持、保護及び改善のため
(2) 本サービス内で表示される生成物の生成その他本サービスの提供のため
(3) 本サービスの保守、管理、改善、品質向上のため
(4) 利用者のトラフィック測定及び行動測定のため
(5) 広告等の配信、表示及び効果測定のため（広告主又はアフィリエイトサービスプロバイダー（以下「広告主等」といいます。）に対してCookie情報その他成果測定に必要な情報を提供の上、広告主等が自らの保有する個人データと照合の上、成果測定を行うことがあります。）
(6) 本サービスに関するご案内、ご連絡、ご請求、お問い合わせへの対応等のため
(7) キャンペーン、アンケート等の実施のため
(8) 市場調査、分析、広告宣伝などマーケティング及び調査研究のため
(9) 個人を識別できない形式に加工した統計データを作成するため
(10) 本サービスに関する当社の利用規約、ポリシー等（以下「規約等」といいます。）に違反する行為に対する対応のため
(11) 不正行為等の防止及び対応のため
(12) 本サービスに関する規約等の変更などの通知、その他利用者へのご連絡のため
(13) 新たなサービス等の企画、研究、開発のため
(14) 本ポリシー記載の第三者提供のため`}></LecalSection>

<LecalSection title="3. 第三者提供" value={`当社は、取得した利用者の情報のうち、個人情報については、次に掲げる場合又は法令に基づく場合を除き、第三者（委託先を除きます。）に提供しません。利用者は、利用者の情報について、次に掲げる第三者提供に予め同意するものとします。
(1) 利用者が本サービスを利用するにあたり、本サービスと他の外部サービスとの連携のために利用者の情報を当該外部サービス事業者に提供する場合
(2) 利用者に対する広告等の配信のために、利用者の情報を、広告配信サービス等を提供する提携事業者に提供する場合
(3) 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を委託する場合
(4) 合併その他の事由による事業の承継に伴って個人情報が提供される場合
(5) 国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、利用者の同意を得ることによって当該事務の遂行に支障を及ぼすおそれがある場合
(6) 人の生命、身体又は財産の保護のために必要がある場合であって、利用者の同意を得ることが困難である場合
(7) 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、利用者の同意を得ることが困難である場合
(8) その他法令で認められる場合`}></LecalSection>

<LecalSection title="4. 個人情報の管理" value={`当社は、利用者の個人情報の漏えい、滅失、又は毀損の防止その他利用者の個人情報の安全管理のために、主に以下の方法等により必要かつ適切な措置を講じています。
(1) 利用者からご提供いただいた個人情報については、正確かつ最新の情報となるよう努めるとともに、当該個人情報が不要となったときは消去するよう努めます。
(2) 本サービスは、個人情報の漏えいや滅失又は毀損を防止するために、適切なセキュリティ対策を実施して個人情報を保護します。`}></LecalSection>

<LecalSection title="5. 個人情報の開示等の請求" value={`5-1 当社は、利用者から、個人情報保護法の定めに基づき保有個人データの利用目的の通知、保有個人データ又は第三者提供の記録の開示、保有個人データの内容の訂正・追加・削除、保有個人データの利用の停止・消去・第三者提供の停止のご請求（あわせて以下「個人情報の開示等の請求」といいます。）があった場合は、利用者ご本人からのご請求であることを確認できた場合に限り、当社所定の手続きに従い、個人情報の開示等の請求に法令の定めに基づき適切に対応いたします。但し、個人情報保護法その他の法令により当社が義務を負わない場合は、この限りではありません。
5-2 利用目的の通知、保有個人データの開示又は第三者提供記録の開示につきましては、手数料としてご請求1件につき1,000円（消費税別）をお支払いいただきますので、あらかじめ御了承ください。
5-3 個人情報の開示等の請求の具体的な方法については、本ポリシー記載の当社のお問い合わせ窓口にお問い合わせください。
5-4 本サービスの利用の前提となる情報の停止、訂正、削除、消去等については、利用者からの個人情報の開示等の請求により、本サービスが利用できなくなることがありますので、あらかじめ御了承ください。`}></LecalSection>

<LecalSection title="6. 第三者によるCookie情報の取得等について" value={`6-1 本サービスでは、Googleによるアクセス解析ツール「Googleアナリティクス」を利用しています。このGoogleアナリティクスはアクセス情報の収集のためにCookieを使用しています。このアクセス情報は匿名で収集されており、個人を特定するものではありません。
6-2 利用者は、お使いのブラウザの操作によりCookieを無効にすることで、収集を拒否することが出来ますので、お使いのブラウザの設定をご確認ください。但し、Cookieの利用を拒否し又はCookieを削除した場合、認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。
6-3 Googleアナリティクスの利用規約やGoogleのプライバシーポリシー、「GOOGLEのサービスを使用するサイトやアプリから収集した情報のGOOGLEによる使用」等に関して確認したい場合は、同社のサイトをご覧ください。
6-4 本サービスでは、GoogleやMetaなどをはじめとする第三者から配信される広告が掲載される場合があり、これに関連して当該第三者が利用者のCookie情報等を取得して、利用している場合があります。当該第三者によって取得されたCookie情報等は、当該第三者のプライバシーポリシー等に従って取り扱われます。
6-5 利用者は、当該第三者のウェブサイト内に設けられたオプトアウト（個人情報を第三者に提供することを停止すること）ページにアクセスして、当該第三者によるCookie情報等の広告配信への利用を停止することができます。`}></LecalSection>

<LecalSection title="7. Cookie情報の送受信の許可・拒否について" value={`利用者は、Cookieの送受信に関する設定を「すべてのCookieを許可する」、「すべてのCookieを拒否する」、「Cookieを受信したらユーザーに通知する」などから選択できます。設定方法は、ブラウザにより異なります。Cookieに関する設定方法は、お使いのブラウザの「ヘルプ」メニューでご確認ください。Cookieの利用を拒否し又はCookieを削除した場合、認証が必要なサービスを受けられなくなる等、インターネット上の各種サービスの利用上、制約を受ける場合がありますのでご注意ください。`}></LecalSection>

<LecalSection title="8. 個人関連情報の取得" value={`当社は、第三者から、識別子や行動履歴など、利用者に関連する情報（個人関連情報）の提供を受け、当該情報を当社が管理する利用者の個人情報と紐づけることで個人情報として取得し、上記「2.利用目的」で規定した目的にしたがって、当該情報を利用することがございます。具体的には、Cookie等、モバイル広告識別子、メールアドレスや電話番号（不可逆的な変換処理がなされたものを含みます。）、広告の閲覧回数等の広告配信関連ログ、ウェブサイトの閲覧履歴や検索履歴、位置情報その他の行動履歴等を取得し、当社が管理する個人情報と紐づけて利用する場合がございます。この場合は、個人情報保護法をはじめとした適用法令に従い、個人情報として適切に取り扱います。`}></LecalSection>

<LecalSection title="9. お問い合わせ窓口" value={`ご意見、ご質問、苦情のお申出その他利用者の情報の取扱いに関するお問い合わせは、下記メールアドレスにてお問い合わせください。
メールアドレス：support_drop.ai@go2mkt.co.jp`}></LecalSection>

<LecalSection title="10. プライバシーポリシーの変更手続" value={`当社は、必要に応じて、随時、本ポリシーを変更する場合があります。当社は、本ポリシーを変更する場合には、当該変更について本サービスのウェブサイト上での掲載その他の適切な方法により周知します。利用者は、本サービスのウェブサイト上に掲載される最新の本ポリシーの内容をご確認ください。`}></LecalSection>

 <div className="mt-10">【2024年11月1日制定】</div>
 <div>【2026年2月6日改定】</div>
 
    </PageSection>
  </>;
}
